import React, { useContext } from 'react';
import { Redirect, Route } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { AuthContext } from '../Context/AuthContext';

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { setIsLoggedIn } = useContext(AuthContext);
  const cookies = new Cookies();
  const accessToken = cookies.get('access_token');

  if (accessToken) {
    setIsLoggedIn(true);
  }

  return (
    <Route
      {...rest}
      render={(routeProps) =>
        accessToken !== undefined ? (
          <Component {...routeProps} />
        ) : (
          <Redirect
            to={{
              pathname: '/',
              state: {
                from: routeProps.location,
              },
            }}
          />
        )
      }
    />
  );
};

export default PrivateRoute;
